import {
  setAIAffectsContent,
  showSideTeamStatusBar,
  tabHighlight,
} from '@/router/classic/helpers';

export function doRootRoster() {
  setAIAffectsContent(true, 'roster');

  if (!$dtw.vwWorkplace) {
    $dt.rtrWPGoto = function() {
      tabHighlight('roster');
      $dtw.vwWorkplace.roster();
    };
    return;
  }

  tabHighlight('roster');
  showSideTeamStatusBar(false);

  if ($dtw.vwWorkplace.appRoster) {
    // is there a rostering app?
    $dtw.vwWorkplace.appRoster.launch();
    $dtw.vwWorkplace.showAppWrapper();
    $dt.resizeViewport(); // Resize the viewPort in desktop here @added by Caesar Li 9th, Oct, 2012
  } else {
    $dtw.vwWorkplace.roster(); // $dt.objLoginUser.EmployeeProfileObject.Company
  }
}
